import * as React from 'react';

import { formatText } from 'bernie-l10n';

import { ExtendedContextStore, FooterSection } from 'types/flex-definitions';

import { UitkCardAloha, UitkCardAlohaContentSection } from 'uitk-react-cards';
import { UitkSpacing } from 'uitk-react-spacing';

import { SwxlFooterSection } from './swxl-footer-section';

interface SwxlFooterProps {
  context: ExtendedContextStore;
  className?: string;
}

export const SwxlFooter: React.FC<SwxlFooterProps> = ({ context, className }: SwxlFooterProps) => {
  const { viewModelResponse, footer } = context;

  // Using the Hotel-Information-Blossom template (https://flexmanager.prod.expedia.biz/app/legacy/flexTemplate/show/19547)
  const links =
    viewModelResponse?.composition?.page?.regionList?.[2]?.modules.find(module => module.name === 'link-juice')?.model.categories || [];
  const linksFooterV2 = footer?.tripPlanningSections || [];
  const finalFooter = [...links, ...linksFooterV2];

  return (
    finalFooter.length > 0 && (
      <div data-stid="swxl-footer" className={className}>
        <SwxlFooterSections title={formatText('hotels.infosite.sxwl.footer.tripPlanning')} sections={finalFooter} />
      </div>
    )
  );
};

interface SwxlFooterSectionsProps {
  title: string;
  sections: FooterSection[];
}

const SwxlFooterSections: React.FC<SwxlFooterSectionsProps> = ({ title, sections }: SwxlFooterSectionsProps) => (
  <UitkCardAloha className="all-y-padding-three">
    <UitkSpacing padding={{ inlinestart: 'three' }}>
      <h3 className="uitk-type-heading-600">{title}</h3>
    </UitkSpacing>
    {sections
      .filter(item => item)
      .map((item, index) => (
        <UitkCardAlohaContentSection padded={false} key={item.name ? item.name : item.title}>
          <SwxlFooterSection headerTitle={title} title={item.name ? item.name : item.title} links={item.links} indexKey={index} />
        </UitkCardAlohaContentSection>
      ))}
  </UitkCardAloha>
);
